import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const UserGreenWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default UserGreenWorkReport
